import React, { useState } from 'react';
import Navigation from '../common/Navigation';
import PrimaryButton from '../common/PrimaryButton';
import SecondarySectionLayout from '../layout/SecondarySectionLayout';
import TestCard from '../common/pagecomponents/TestCard';
import { graphql, navigate, useStaticQuery } from 'gatsby';
import AniLink from 'gatsby-plugin-transition-link/AniLink';
import VideoWrapper from '../common/VideoWrapper';

const WorldClassContent = () => {
    const [activeNavigationTab, setActiveNavigationTab] =
        useState('Mock Tests');

    const navigationTabClick = (clickedTabId) => {
        clickedTabId === 'Mock Tests'
            ? setActiveNavigationTab('Mock Tests')
            : setActiveNavigationTab('Videos');
    };

    const data = useStaticQuery(query);

    const {
        allStrapiHomeWorldClassContent: { nodes: HomeWorldClassContent },
        allStrapiTest: { nodes: HomeWorldClassContentQuiz },
        allQuiz: { nodes: Quizes },
        allStrapiVideo: { nodes: HomeWorldClassContentVideos },
    } = data;

    const {
        home_worldClassContent_heading,
        home_worldClassContent_navigation,
        home_worldClassContent_button_mockTest,
        home_worldClassContent_button_video,
    } = HomeWorldClassContent[0];

    const homepageQuiz = HomeWorldClassContentQuiz.reduce((acc, item) => {
        const quizId = item.Test_Card.quiz_id;
        const matchingEntries = Quizes.filter(
            (entry) => entry.quiz_id === parseInt(quizId)
        );
        acc.push(...matchingEntries);
        return acc;
    }, []);

    // let courseSlug = [];

    // HomeWorldClassContentQuiz.forEach((element) => {
    //     if (element.courseSlug.length) {
    //         element.courseSlug.forEach((e) => {
    //             courseSlug.push(e.slug);
    //         });
    //     }
    // });
    // console.log('HomeWorldClassContentVideos', HomeWorldClassContentVideos);
    const videoNavigation = (Slug) => {
        navigate(`/single-videos/${Slug}`);
    };
    return (
        <>
            <SecondarySectionLayout
                SecondarySectionAltHeading={home_worldClassContent_heading}
            >
                <Navigation
                    FilterButtonData={home_worldClassContent_navigation}
                    FilterButtonFunction={navigationTabClick}
                    ActiveTab={activeNavigationTab}
                >
                    <div
                        className={
                            activeNavigationTab === 'Mock Tests'
                                ? 'world_class_content_test_card_wrapper'
                                : 'non_active'
                        }
                    >
                        {homepageQuiz.map((quizItem) => (
                            <TestCard
                                key={quizItem.id}
                                TestName={quizItem.website_display_name}
                                TestType={quizItem.module_type}
                                Duration={quizItem.duration}
                                TestUrl={`https://app.ieltsninja.com/app-login/?next=/quiz/${quizItem.quiz_id}/`}
                            />
                        ))}
                    </div>
                    <div
                        className={
                            activeNavigationTab === 'Videos'
                                ? 'world_class_content_test_card_wrapper'
                                : 'non_active'
                        }
                    >
                        {HomeWorldClassContentVideos.map((homeVideosItem) => (
                            <VideoWrapper
                                key={homeVideosItem.id}
                                ThumbnailUrl={
                                    homeVideosItem.Video_Card.video_thumbnail
                                        .url
                                }
                                MaxWidth={310}
                                PlayBtnUrl={
                                    'https://s3.us-east-2.wasabisys.com/ufaber-lms/files/1f977ee24b62b3ed194afd01468d43d2.svg'
                                }
                                VideoFunction={() =>
                                    videoNavigation(homeVideosItem.slug)
                                }
                            />
                        ))}
                    </div>
                </Navigation>
                {activeNavigationTab === 'Mock Tests' ? (
                    <AniLink
                        fade
                        to={
                            home_worldClassContent_button_mockTest.button_redirection
                        }
                    >
                        <PrimaryButton
                            ButtonText={
                                home_worldClassContent_button_mockTest.button_text
                            }
                            MaxWidth={13.9375}
                        />
                    </AniLink>
                ) : (
                    <AniLink
                        fade
                        to={
                            home_worldClassContent_button_video.button_redirection
                        }
                    >
                        <PrimaryButton
                            ButtonText={
                                home_worldClassContent_button_video.button_text
                            }
                            MaxWidth={13.9375}
                        />
                    </AniLink>
                )}
            </SecondarySectionLayout>
        </>
    );
};

const query = graphql`
    {
        allStrapiHomeWorldClassContent {
            nodes {
                home_worldClassContent_heading
                home_worldClassContent_navigation {
                    id
                    navigation_tab_name
                }
                home_worldClassContent_button_mockTest {
                    button_text
                    button_redirection
                }
                home_worldClassContent_button_video {
                    button_text
                    button_redirection
                }
            }
        }
        allQuiz {
            nodes {
                quiz_id
                test_type
                module_type
                website_display_name
                duration
                id
            }
        }
        allStrapiTest(
            filter: { Test_Card: { published_homepage: { eq: true } } }
        ) {
            nodes {
                Test_Card {
                    quiz_id
                }
                courseSlug {
                    id
                    slug
                }
            }
        }
        allStrapiVideo(filter: { published_homepage: { eq: true } }) {
            nodes {
                id
                courseSlug {
                    id
                    slug
                }
                Video_Card {
                    video_thumbnail {
                        url
                    }
                }
                slug
            }
        }
    }
`;

export default WorldClassContent;
